// extracted by mini-css-extract-plugin
export default {"title":"delete_title__JUvQF","buttonPart":"delete_buttonPart__CMhVG","buttonCancel":"delete_buttonCancel__EWaSq","buttonDelete":"delete_buttonDelete__+o3tx"};